import { routes } from '@/lib/routes'

export type NavLink = {
    label: string
    href: string
    external?: boolean
}

export type NavColumn = {
    heading: string
    links: NavLink[]
}

export type SocialLink = {
    label: string
    href: string
    icon: string
}

// Featured entries shown as icon + title + description rows in the mega menu.
export type MegaMenuItem = {
    label: string
    href: string
    description: string
    icon: string
    external?: boolean
}

// Top-level nav links shown inline in the header.
export const primaryLinks: NavLink[] = [
    { label: 'Features', href: routes.features },
    { label: 'Company', href: routes.company }
]

// Featured pages shown as the main grid of the "Pages" mega menu.
export const megaMenuItems: MegaMenuItem[] = [
    { label: 'Home', href: routes.home, description: 'Back to the San Diego homepage', icon: 'home' },
    { label: 'Features', href: routes.features, description: 'Everything San Diego can do for you', icon: 'sparkles' },
    { label: 'Pricing', href: routes.pricing, description: 'Simple plans for every team size', icon: 'tag' },
    { label: 'Company', href: routes.company, description: 'The team and story behind us', icon: 'building' },
    { label: 'Support', href: routes.support, description: 'Guides and answers when you need them', icon: 'lifebuoy' },
    { label: 'Contact', href: routes.contact, description: 'Get in touch with our team', icon: 'mail' },
    { label: 'Blog', href: routes.blog, description: 'Product updates, tips, and ideas', icon: 'book' }
]

// Compact secondary links shown in the mega menu footer strip.
export const secondaryLinks: NavLink[] = [
    { label: 'Article Detail', href: routes.blogPost('get-running') },
    { label: 'Blog Category', href: routes.blogCategory('product') },
    { label: 'Support Detail', href: routes.supportArticle('how') },
    { label: 'Search', href: routes.search },
    { label: 'Privacy', href: routes.privacy }
]

// Social profiles (icons live in /public/images).
export const socialLinks: SocialLink[] = [
    { label: 'Instagram', href: 'https://instagram.com', icon: '/images/instagram.svg' },
    { label: 'Twitter', href: 'https://twitter.com', icon: '/images/twitter.svg' },
    { label: 'LinkedIn', href: 'https://linkedin.com', icon: '/images/linkedin.svg' },
    { label: 'Facebook', href: 'https://facebook.com', icon: '/images/facebook.svg' }
]

// Footer link columns.
export const footerColumns: NavColumn[] = [
    {
        heading: 'Product',
        links: [
            { label: 'Home', href: routes.home },
            { label: 'Features', href: routes.features },
            { label: 'Pricing', href: routes.pricing },
            { label: 'Support', href: routes.support }
        ]
    },
    {
        heading: 'Company',
        links: [
            { label: 'About', href: routes.company },
            { label: 'Blog', href: routes.blog },
            { label: 'Privacy', href: routes.privacy },
            { label: 'Contact', href: routes.contact }
        ]
    },
    {
        heading: 'Resources',
        links: [
            { label: 'Article Detail', href: routes.blogPost('get-running') },
            { label: 'Support Detail', href: routes.supportArticle('how') },
            { label: 'Blog Category', href: routes.blogCategory('product') },
            { label: 'Search', href: routes.search }
        ]
    }
]
